import React, { ReactNode } from "react"
import { Button, Modal } from "react-bootstrap"
import DraggableModal from "./DraggableModal"

// other

// React

export type TModalTypes = {
  isShow: boolean
  title: string | ReactNode
  setIsShow: (value: boolean) => unknown
  size?: "sm" | "lg" | "xl"
  dialogClassName?: string
  isDisabledCloseButton?: boolean
}

/**
 * モーダル
 */
export const ModalOuter: React.FC<TModalTypes & { footer?: ReactNode }> = ({
  isShow,
  setIsShow,
  title,
  footer,
  children,
  isDisabledCloseButton,
  ...props
}) => {
  /**
   * モーダルダイアログ非表示時のイベントハンドラ
   *
   */
  const onHideModal = () => {
    setIsShow(false)
  }

  return (
    <DraggableModal
      {...props}
      size={props.size ?? "xl"}
      show={isShow}
      onHide={() => onHideModal()}
      dialogClassName={props.dialogClassName ?? "popupMenu"}
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton={false}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        {footer}
        <Button
          disabled={isDisabledCloseButton}
          variant="secondary"
          onClick={() => onHideModal()}>
          閉じる
        </Button>
      </Modal.Footer>
    </DraggableModal>
  )
}
